import { render, staticRenderFns } from "./AddOn.vue?vue&type=template&id=d6fda8e8&scoped=true&"
import script from "./AddOn.vue?vue&type=script&lang=js&"
export * from "./AddOn.vue?vue&type=script&lang=js&"
import style0 from "./AddOn.vue?vue&type=style&index=0&id=d6fda8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fda8e8",
  null
  
)

export default component.exports